'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderTrackVerticalDefault = renderTrackVerticalDefault;

require('@deskpro/apps-components-style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCustomScrollbars = require('react-custom-scrollbars');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function renderTrackVerticalDefault(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ['style']);

  var finalStyle = _extends({}, style, {
    right: 0,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return _react2.default.createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVertical(_ref2) {
  var style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ['style']);

  var finalStyle = _extends({}, style, {
    right: 0
  });

  return _react2.default.createElement('div', { className: 'dp-ScrollableThumb', style: finalStyle });
}

var List = function List(_ref3) {
  var children = _ref3.children,
      height = _ref3.height,
      className = _ref3.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("dp-Scrollable dp---is-hooverable", className) },
    _react2.default.createElement(
      _reactCustomScrollbars.Scrollbars,
      {
        autoHeight: true,
        autoHeightMin: height,
        renderThumbVertical: renderThumbVertical,
        renderTrackVertical: renderTrackVerticalDefault
      },
      children
    )
  );
};

List.propTypes = {

  /**
   * the height of the list in pixels
   */
  height: _propTypes2.default.number,

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string,

  /**
   * a list of children to render.
   */
  children: _propTypes2.default.array
};

List.defaultProps = {
  height: 50
};

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/List/List.js
// module id = 343
// module chunks = 0